import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import "./msgs/ClientMsgReceiver";
import { requestLicense, requestLicenseCUUsage } from "./msgs/MsgSender";
import licenseStore, { LicenseContext } from "./licenseStore";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

interface IProps {
    appID?: string;
    children: ReactNode;
}

function LicenseProvider(props: IProps) {
    useEffect(() => {
        requestLicense({ value: getGlobalStates().systemID });
        requestLicenseCUUsage();
    }, []);

    return (
        <Provider store={licenseStore} context={LicenseContext}>
            {props.children}
        </Provider>
    );
}

export default LicenseProvider;
